<template>
  <div
    @click="$emit('clicked')"
    class="add-human-button">
    <bordered-add-button
      class="add-human-button__image"
      :width="width"
      :height="height"
      :variant="variant"
    />
    <span
      v-if="showText"
      class="add-human-button__text"
    >
      {{ text || $t('addHumanButton.addParticipants')}}
    </span>
  </div>
</template>

<script>
import BorderedAddButton from '../BorderedAddButton/BorderedAddButton';

export default {
  name: 'AddHumanButton',
  components: {
    BorderedAddButton,
  },
  props: {
    width: {
      type: String,
      default: '45px',
    },
    height: {
      type: String,
      default: '45px',
    },
    text: {
      type: String,
      default: '',
    },
    showText: {
      type: Boolean,
      default: true,
    },
    variant: {
      type: String,
      default: 'edit',
      validate: (val) => ['add', 'edit', 'settings'].includes(val),
    },
  },
};
</script>

<style lang="scss" scoped>
  .add-human-button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 64px;
    width: 200px;
    color: var(--btn-primary);
    z-index: 1;
    cursor: pointer;
  }

  .add-human-button:hover {
    filter: saturate(200%) brightness(60%);
  }

  .add-human-button__image {
    z-index: 3;
  }
  .add-human-button__text {
    width: calc(100% - 52px);
  }
</style>
